if (!window.featureShowcaseInit) {
window.featureShowcaseInit = true;

const initFeatureShowcase = (section) => {
  const mediaWrap = section.querySelector('.feature-showcase__media-wrap');
  if (!mediaWrap) return;

  const media = mediaWrap.querySelector('.feature-showcase__media');
  const items = mediaWrap.querySelectorAll('.feature-showcase__media-item');
  const dots = mediaWrap.querySelectorAll('.feature-showcase__media-dot');
  const prevButton = section.querySelector('.feature-showcase__arrow--prev');
  const nextButton = section.querySelector('.feature-showcase__arrow--next');
  if (!media || items.length === 0 || dots.length === 0) return;

  const ensureItemLoaded = (index) => {
    const item = items[index];
    if (!item) return;
    const image = item.querySelector('.feature-showcase__media-image');
    if (!image) return;
    if (!image.getAttribute('src') && image.dataset.src) {
      image.setAttribute('src', image.dataset.src);
    }
    if (!image.getAttribute('srcset') && image.dataset.srcset) {
      image.setAttribute('srcset', image.dataset.srcset);
    }
  };

  const setActive = (index) => {
    ensureItemLoaded(index);
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    if (prevButton) {
      prevButton.classList.toggle('is-hidden', index <= 0);
    }
    if (nextButton) {
      nextButton.classList.toggle('is-hidden', index >= items.length - 1);
    }
  };

  const getActiveIndex = () => {
    const containerRect = media.getBoundingClientRect();
    let activeIndex = 0;
    let maxVisible = -1;
    items.forEach((item, index) => {
      const rect = item.getBoundingClientRect();
      const visibleLeft = Math.max(rect.left, containerRect.left);
      const visibleRight = Math.min(rect.right, containerRect.right);
      const visibleWidth = Math.max(0, visibleRight - visibleLeft);
      if (visibleWidth > maxVisible) {
        maxVisible = visibleWidth;
        activeIndex = index;
      }
    });
    return activeIndex;
  };

  const scrollToIndex = (index) => {
    const targetIndex = Math.max(0, Math.min(index, items.length - 1));
    const target = items[targetIndex];
    if (!target) return;
    ensureItemLoaded(targetIndex);
    ensureItemLoaded(targetIndex + 1);
    setActive(targetIndex);
    media.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
  };

  let rafId = null;
  const onScroll = () => {
    if (rafId) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      setActive(getActiveIndex());
    });
  };

  dots.forEach((dot) => {
    dot.addEventListener('click', (event) => {
      event.preventDefault();
      const index = Number(dot.dataset.index);
      const target = items[index];
      if (!target) return;
      scrollToIndex(index);
    });
  });

  media.addEventListener('scroll', onScroll, { passive: true });

  ensureItemLoaded(0);
  ensureItemLoaded(1);
  setActive(0);

  if (prevButton) {
    prevButton.addEventListener('click', (event) => {
      event.preventDefault();
      scrollToIndex(getActiveIndex() - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', (event) => {
      event.preventDefault();
      scrollToIndex(getActiveIndex() + 1);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.feature-showcase').forEach((section) => {
    if (section.dataset.enhanced) return;
    section.dataset.enhanced = 'true';
    initFeatureShowcase(section);
  });
});
}
